// @flow

import { del, get, post, put } from '../utils/api';
import type {
  TourBlockout,
  TourBlockoutPayload,
} from '../containers/TourBlockouts/types';

// Tour Blockouts: time at a property when some of its tour slots are taken.
// Every endpoint is tenant-scoped under `/{organizationId}/{propertyId}/`.
//
// `fullError` makes a refusal reject with the backend's error body
// (`{ statusCode, message, data: { code } }`) rather than its message alone,
// so a form can show the message and mark the field whose rule `code` names.
const FULL_ERROR = { fullError: true };

export default class TourBlockoutService {
  getTourBlockoutList(
    organizationId: string,
    propertyId: string,
  ): Promise<Array<TourBlockout>> {
    return get(`/${organizationId}/${propertyId}/tour-blockouts`, FULL_ERROR);
  }

  createTourBlockout(
    organizationId: string,
    propertyId: string,
    payload: TourBlockoutPayload,
  ): Promise<TourBlockout> {
    return post(
      `/${organizationId}/${propertyId}/tour-blockouts`,
      JSON.stringify(payload),
      FULL_ERROR,
    );
  }

  updateTourBlockout(
    organizationId: string,
    propertyId: string,
    tourBlockoutId: string,
    payload: TourBlockoutPayload,
  ): Promise<TourBlockout> {
    return put(
      `/${organizationId}/${propertyId}/tour-blockouts/${tourBlockoutId}`,
      JSON.stringify(payload),
      FULL_ERROR,
    );
  }

  deleteTourBlockout(
    organizationId: string,
    propertyId: string,
    tourBlockoutId: string,
  ): Promise<{ id: string }> {
    return del(
      `/${organizationId}/${propertyId}/tour-blockouts/${tourBlockoutId}`,
      undefined,
      FULL_ERROR,
    );
  }
}
